<template>
  <div class="terms-page">
    <h1>Terms & Conditions</h1>

    <h2>Check-in</h2>
    <p>15:00 - 22:00</p>
    <p>
      Guests are required to show a photo identification and credit card upon
      check-in. If you require a later check-in than 22:00, please let us know
      so that we can help to arrange.
    </p>

    <h2>Check-out</h2>
    <p>00:00 - 11:00</p>

    <h2>Refundable damage deposit</h2>
    <p>
      A damage deposit of CAD 250 is required on arrival. You should be
      reimbursed on check-out after inspection of the room. Your deposit will be
      refunded in full, subject to an inspection of the property.
    </p>

    <h2>Children and beds</h2>
    <p>Ode is adults only, unfortunately children are not allowed.</p>

    <h2>Cot and extra bed policies</h2>
    <p>There is no capacity for cots or extra beds at this property.</p>

    <h2>Age restriction</h2>
    <p>The minimum age for check-in is 21.</p>

    <h2>Pets</h2>
    <p>Pets are not allowed.</p>

    <h2>Payment Policy</h2>
    <p>
      100% of booking cost is due on booking in order to secure your
      reservation.
    </p>

    <h2>Cancellation/prepayment</h2>
    <p>
      You may cancel your reservation for no charge thirty (30) days prior to
      arrival. Any cancellations made within thirty days of check-in will be
      charged for 100% of the booking.
    </p>
  </div>
</template>

<script>
export default {
  head() {
    return {
      title: "Terms & Conditions",
    };
  },
};
</script>

<style scoped>
.terms-page {
  padding: 150px 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}

h1 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 2em;
}

h2 {
  margin-top: 20px;
  font-size: 1.5em;
  color: #333;
}

p {
  margin-bottom: 15px;
  line-height: 1.6;
  font-size: 1em;
  color: #555;
}

@media (max-width: 768px) {
  h1 {
    font-size: 1.8em;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 1.3em;
  }

  p {
    font-size: 0.95em;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.5em;
  }

  h2 {
    font-size: 1.2em;
  }

  p {
    font-size: 0.9em;
  }
}
</style>
